import { orderBy } from "lodash";
import React from "react";
import { Grid } from "../../../../../components/Grid";
import RenderWhen from "../../../../../components/RenderWhen";
import ThreeDotsLoader from "../../../../../components/three-dots-loader/ThreeDotsLoader";
import { RLcsAnalysisResponseData } from "../../../../samples/components/rlcloudsandbox/hooks/useRlcsAnalysisStatus";
import { RlCloudSandboxSignaturesGridSchema } from "../../../../samples/components/rlcloudsandbox/signatures/RlCloudSandboxSignaturesGridSchema";
import { getCloudSandboxAnalyzingCount } from "../../../../samples/components/subheader/card/dynamic_analysis/utils";
import styles from "./network-lists.module.scss";
import { ReportCloudSandbox } from "../../../../samples_cloud/@types";
import { RLCSMergedReportResponse } from "../../../../samples/@types/rldynamicanalysis/rlcs-responses";

interface LoadingProps {
  isLoading?: boolean;
  displayStatus?: RLcsAnalysisResponseData;
}

const LoadingComponent = ({ isLoading, displayStatus }: LoadingProps) => {
  const analyzingCount = getCloudSandboxAnalyzingCount(displayStatus);
  return (
    <div className={styles.status_msg}>
      <span>
        {isLoading ? "Loading" : `Analyzing ${analyzingCount > 1 ? "(2)" : ""}`}
      </span>
      <ThreeDotsLoader />
    </div>
  );
};

interface NoDataComponentProps {
  showAnalyzeMessage: boolean;
  rlcsAnalyzeModalToggle: () => void;
}

const NoDataComponent = ({
  showAnalyzeMessage,
  rlcsAnalyzeModalToggle
}: NoDataComponentProps) => (
  <RenderWhen
    condition={showAnalyzeMessage}
    fallback={
      <div className={styles.empty_msg}>
        <span
          className={"network-threat-intel-link k-pdf-rl-cloud-sandbox-analyze"}
          onClick={rlcsAnalyzeModalToggle}
          data-test-id="analyze-rlcs-card-findings"
        >
          Analyze with RL Cloud Sandbox
        </span>
        <span> to gather dynamic analysis data</span>
      </div>
    }
  >
    <span className={styles.empty_msg}>No Available Signatures</span>
  </RenderWhen>
);

interface Props {
  rlcsReport?: ReportCloudSandbox | RLCSMergedReportResponse;
  rlcsAnalyzeModalToggle: () => void;
  isAnalyzing?: boolean;
  isLoading?: boolean;
  analysisStatusData?: RLcsAnalysisResponseData;
  to?: string;
}

const DynamicAnalysisFindingsList: React.FC<Props> = ({
  rlcsReport,
  rlcsAnalyzeModalToggle,
  isAnalyzing,
  isLoading,
  analysisStatusData,
  to
}) => {
  const sortedData = orderBy(
    rlcsReport?.signatures,
    ["risk_factor"],
    ["desc"]
  ).slice(0, 5);
  return (
    <div className="flex-column">
      <Grid
        data={sortedData}
        schema={RlCloudSandboxSignaturesGridSchema(true, to)}
        emptyGridMsg={
          <NoDataComponent
            showAnalyzeMessage={Boolean(rlcsReport)}
            rlcsAnalyzeModalToggle={rlcsAnalyzeModalToggle}
          />
        }
        showLoading={isLoading || isAnalyzing}
        LoadingComponent={
          <LoadingComponent
            isLoading={isLoading}
            displayStatus={analysisStatusData}
          />
        }
        testId="nti_dynamic_analysis_findings_table"
      />
    </div>
  );
};
export default DynamicAnalysisFindingsList;
